import type { FC } from "react";

import { Card, CardRowSimple, type GridCard } from "widgets";

import { GenericTile } from "../../core/tiles/index.js";
import type { ExternalReference } from "@/graphql.ts";

export interface IReferencesCardProps extends GridCard {
  title?: string;
  references: ExternalReference[];
}

const ReferencesCard: FC<IReferencesCardProps> = (props) => {
  if (props.references.length === 0) {
    return null;
  }

  return (
    <Card
      shrinkable={props.references.length > 7}
      title={props.title ?? "External References"}
      tag={{ label: String(props.references.length) }}
      icon={"share"}
    >
      <CardRowSimple>
        {props.references.map((ref, index) => {
          const description = ref.title ? (
            <>
              {ref.title && <span>{ref.title}</span>} {ref.citation && <em>{ref.citation}</em>}
            </>
          ) : ref.description !== ref.displayName ? (
            ref.description
          ) : null;
          const link = ref.link ? new URL(ref.link).host : undefined;

          return (
            <GenericTile
              title={ref.displayName}
              to={ref.link}
              forceExternal
              footNote={description ?? link}
              key={`reference-card-${index}`}
            />
          );
        })}
      </CardRowSimple>
    </Card>
  );
};

export { ReferencesCard };
